export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10017.2e260a22.jpg";